import React, { useEffect, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
interface TinyMCEEditorProps {
  initialValue?: string;
  onChange?: (content: string) => void;
  height?: number | string;
  readOnly?: boolean;
}

const TinyMCEEditor: React.FC<TinyMCEEditorProps> = ({ initialValue, onChange, height, readOnly = false }: TinyMCEEditorProps) => {
  const editorRef = useRef<any>(null);


  return (
    <Editor
      licenseKey="gpl" // Acknowledge GPL license for self-hosted version
      tinymceScriptSrc="/tinymce/tinymce.min.js" // Path to your self-hosted TinyMCE
      onInit={(evt: any, editor: any) => {
        editorRef.current = editor;
        editor.focus();
        editor.selection.setCursorLocation(editor.getBody(), 0);
      }}
      value={initialValue}
      onEditorChange={(content: string) => {
        //console.log('content', content);
        if (onChange) onChange(content);
      }}
      init={{
        width: '100%',
        height: height || '65vh',
        relative_urls: false,
        convert_urls: false,
        remove_script_host: false,
        menubar: false,
        base_url: '/tinymce', // Help TinyMCE find its resources
        plugins: [
          //'powerpaste',
          'codesample',
          'advlist',
          'autolink',
          'lists',
          'link',
          'image',
          'charmap',
          'preview',
          'anchor',
          'searchreplace',
          'visualblocks',
          'code',
          'fullscreen',
          'insertdatetime',
          'media',
          'table',
          'wordcount',
          //'quickbars',
          'help',
        ],
        toolbar:
          'undo redo |  blocks | bold italic underline strikethrough | ' +
          'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | ' +
          'link image media table | removeformat | code  | help',
        quickbars_insert_toolbar: 'quicktable image media codesample',
        quickbars_selection_toolbar: 'bold italic underline | blocks | bullist numlist | blockquote quicklink',
        contextmenu: 'undo redo | inserttable | cell row column deletetable | help',
        // powerpaste_word_import: 'clean',
        // powerpaste_html_import: 'clean',
        content_style: 'body { font-family:Arial,sans-serif; font-size:14px }',
      }}
    />
  );
};

export default TinyMCEEditor;
